import { Button } from '@playbooks/ui/components/button';
import { Icon } from '@playbooks/ui/components/icon';
import { Sheet, SheetContent, SheetHeader, SheetTitle } from '@playbooks/ui/components/sheet';

import { DocsSidebarBody } from 'components/docs/docs-sidebar-body';

const DocsSlide = ({ open, setOpen }: { open: boolean; setOpen: (open: boolean) => void }) => (
	<>
		<Button variant='ghost' size='icon-sm' aria-label='Open documentation navigation' onClick={() => setOpen(true)}>
			<Icon type='far' icon='bars' aria-hidden />
		</Button>
		<Sheet open={open} onOpenChange={setOpen}>
			<SheetContent side='left' className='w-[min(20rem,85vw)] gap-0 bg-canvas p-0'>
				<SheetHeader className='border-b px-5 py-4'>
					<SheetTitle>Documentation</SheetTitle>
				</SheetHeader>
				<div className='custom-scrollbar overflow-y-auto px-3 py-5'>
					<DocsSidebarBody onNavigate={() => setOpen(false)} />
				</div>
			</SheetContent>
		</Sheet>
	</>
);

export { DocsSlide };
